import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AIPlaygroundInterface } from '../components/AIPlaygroundInterface';
import { RogersVQA } from '../apps/vqa';
import { SettingsApp } from '../components/SettingsApp';
import { BezPlus } from '../apps/bez-plus';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AIPlaygroundInterface onBackToHome={() => { }} />} />
      <Route
        path="/rogers-vqa"
        element={
          <RogersVQA
            onBack={() => window.history.back()}
            onClose={() => window.history.back()}
          />
        }
      />
      <Route
        path="/bez-plus"
        element={
          <BezPlus onBack={() => window.history.back()} />
        }
      />
      <Route
        path="/settings"
        element={
          <SettingsApp
            onBack={() => window.history.back()}
            onClose={() => window.history.back()}
          />
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}